<template>
  <el-container direction="vertical" class="app-wrapper">
    <NavBar>
      <slot name="right-menu"></slot>
      <template #right-menu>
        <slot name="right-menu"></slot>
      </template>
    </NavBar>
    <el-container direction="horizontal" style="overflow: hidden">
      <SideBar v-if="!isHiddenSideBar">
        <!-- 作用域插槽透传 -->
        <template #sidebar-top="slotProps">
          <slot name="sidebar-top" v-bind="slotProps"></slot>
        </template>
        <template #sidebar-bottom="slotProps">
          <slot name="sidebar-bottom" v-bind="slotProps"></slot>
        </template>
      </SideBar>
      <el-container direction="vertical">
        <AppMain />
      </el-container>
    </el-container>
  </el-container>
</template>

<script setup>
import SideBar from './components/SideBar/index.vue'
import NavBar from './components/NavBar/index.vue'
import AppMain from './components/AppMain.vue'

const route = useRoute()
const isHiddenSideBar = computed(() => {
  return route.meta?.hiddenSideBar
})
</script>

<style lang="scss" scoped>
.app-wrapper {
  height: 100%;
  background-color: #f6f8f9;
}
</style>
